/**
 * Platform display names and copy for social post confirmation modals.
 * Review Images and AI Social Posts share platform naming but use different titles/copy.
 */
export function socialPostPlatformName(postingType) {
  if (!postingType) return ''
  const type = String(postingType).toLowerCase()
  if (type === 'gbp' || type === 'google') {
    return 'Google Business Profile'
  }
  return postingType.charAt(0).toUpperCase() + postingType.slice(1)
}

export function socialPostConfirmMessage(postingType) {
  const platform = socialPostPlatformName(postingType)
  if (!platform) return ''
  return `We will create an image from this review and post it to ${platform}.`
}

export const socialPostModalTitle = 'Post review image'

export function fusionPostConfirmMessage(postingType) {
  const platform = socialPostPlatformName(postingType)
  if (!platform) return ''
  return `We will publish this social post to ${platform}.`
}

export const fusionPostModalTitle = 'Publish Social Post'

/**
 * Convert editor/API HTML (or plain text) into clean caption text with newlines.
 */
export function socialPostToPlainText(value) {
  if (value == null || value === '') return ''

  let text = String(value)
  if (!/<[a-z][\s\S]*>/i.test(text)) {
    return text.replace(/\r\n/g, '\n').replace(/\n{3,}/g, '\n\n').trim()
  }

  text = text.replace(/<\s*br\s*\/?\s*>/gi, '\n')
  text = text.replace(/<\/\s*(p|div|li|h[1-6]|tr|blockquote)\s*>/gi, '\n')
  text = text.replace(/<\s*(p|div|li|h[1-6]|blockquote)[^>]*>/gi, '')

  const tmp = document.createElement('div')
  tmp.innerHTML = text
  text = tmp.textContent || tmp.innerText || ''

  return text
    .replace(/\u00a0/g, ' ')
    .replace(/\r\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}

/**
 * Escape plain text and convert newlines to <br> for safe v-html display.
 */
export function socialPostToDisplayHtml(value) {
  const plain = socialPostToPlainText(value)
  if (!plain) return ''

  return plain
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/\n/g, '<br>')
}
